import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Marker } from 'react-google-maps'
import { RichText } from 'prismic-reactjs'
// import websiteIcon from '../../images/website.svg'

import twitterIcon from '../../images/twitter.svg'

import facebookIcon from '../../images/facebook.svg'

import instagramIcon from '../../images/instagram_1.svg'

import linkedinIconGray from '../../images/linkdin.svg'

import MapStyle from '../city-page/map-style'
import LinkResolver from '../../link-resolver'

import Map from '../../components/map'
import NewsletterForm from '../../components/newletter-form'

import mailIcon from '../../images/mail.svg'
// import laptop1Icon from '../../images/laptop1.png'
import contactIcon from '../../images/contact.svg'
// import SGbooksPicture from '../../images/SGbooks.jpg'
// import img4584Picture from '../../images/IMG_4584.jpg'
import openTimesIcon from '../../images/open-times.svg'
// import tipsFingerIcon from '../../images/tips_finger.png'
import locationPinIcon from '../../images/location-pin.svg'
// import workOnBooksIcon from '../../images/workingonbooks.png'
// import aboutStoryPicture from '../../images/about-story-3.png'
// import aboutStory4Picture from '../../images/about-story-4-768x577.png'
// import image11Placeholder from '../../images/image-1-1-placeholder.svg'
import noImage from '../../images/no-image.png'

export default class AboutPage extends Component {
  constructor() {
    super();
    this.state = { mapsPerRow: 3 };

    this.gridsRow = this.gridsRow.bind(this);
  }

  gridsRow = function (q) {
    var num = 3;
    if (q.matches)
      num = 1;

    this.setState(state => ({
      mapsPerRow: num
    }));
  }

  componentDidMount() {
    // listens
    var q = window.matchMedia("(max-width:991px)");

    this.gridsRow(q);
    q.addListener(this.gridsRow);

    // window.addEventListener('resize',this.gridsRow());
  }

  render() {
    const { hash } = window.location
    const contact = this.props.about.contact;
    const story = this.props.about.story;
    const team = this.props.about.team;
    var rowCountBox = Math.ceil((contact.filter((e) => { return e.type === 'contact_box' }).length) / 2.0)
    var rowCountVisit = Math.ceil((contact.filter((e) => { return e.type === 'visit_us' }).length) / this.state.mapsPerRow)
    // console.log("ABOUT",this.props.about)
    const seo = this.props.about.seo, generic = this.props.about.social.generic[0], twitter = this.props.about.social.twitter[0]
    return (
      <div>
        <Helmet>
          <title>Startup Guide - {seo.title ? seo.title : "About"}</title>
          <meta name="description" content={seo.description ? seo.description : 'About'}></meta>

          <meta property="og:title" content={generic && generic.title ? generic.title : 'About'}></meta>
          <meta property="og:description" content={generic && generic.description ? generic.description : 'About us'}></meta>
          {generic && generic.image &&
            <meta property="og:image" content={generic.image}></meta>
          }
          <meta property="og:url" content="https://startupguide.com/about/"></meta>
          <meta property="og:type" content="website"></meta>
          <meta property="og:site_name" content="StartupGuide"></meta>

          <meta name="twitter:card" content={twitter && twitter.type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
          <meta name="twitter:site" content="@StartupGuideHQ"></meta>
          <meta name="twitter:creator" content={twitter && twitter.handle ? twitter.handle : '@StartupGuideHQ'}></meta>
          <meta name="twitter:title" content={twitter && twitter.title ? twitter.title : 'About'}></meta>
          <meta name="twitter:description" content={twitter && twitter.description ? twitter.description : 'About us'}></meta>
          {twitter && twitter.image &&
            <meta name="twitter:image" content={twitter.image}></meta>
          }
        </Helmet>
        <div>
          <div className="page-title-stores" style={{ height: 'fit-content' }}>
            <img src={this.props.about.banner} style={{ opacity: '0', width: '100%' }} alt="" />
            <div style={{
              width: '100%',
              display: 'block',
              height: '100%',
              backgroundImage: 'url(\'' + this.props.about.banner + '\'',
              position: 'absolute',
              top: 0,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
            />
            <div className="description">
              <div className="text-block-65">About us</div>
            </div>
          </div>
          <div data-duration-in={300} data-duration-out={100} className="tabs w-tabs">
            <div className="tabs-menu-2 w-tab-menu">
              <a data-w-tab="Story" id="story" className={"tab-link-tab-1 w-inline-block w-tab-link " + ((hash === '' || hash === '#story') ? 'w--current' : '')} href="#story">
                <div>Story</div>
              </a>
              <a data-w-tab="Team" id="team" className={"tab-link-tab-2 w-inline-block w-tab-link " + ((hash === '#team') ? 'w--current' : '')} href="#team">
                <div>Team</div>
              </a>
              <a data-w-tab="Contact" id="contact" className={"tab-link-tab-3 w-inline-block w-tab-link " + ((hash === '#contact') ? 'w--current' : '')} href="#contact">
                <div>Contact</div>
              </a>
            </div>
            <div className="w-tab-content">
              <div data-w-tab="Story" className={"w-tab-pane " + ((hash === '#story' || hash === '') ? 'w--tab-active' : '')} style={{
                'marginLeft': 'auto',
                'marginRight': 'auto',
              }}>
                {story.map((s, sk) =>
                  <div key={sk} className={((sk > 1 && sk < 5) ? 'about-books-section ' : ' ') + '' + (sk === 2 ? 'first-book-section' : '')}>
                    {s.type === 'paragraph' &&
                      <div className={'div-block-story ' + (s.section.paragraph.content[0].label === 'Align Left' ? 'left-align-text ' : 'right-align-text ')} style={(sk === 2 ? { alignItems: 'baseline' } : (sk === 0 ? { borderTop: '1px solid #dbdbdb' } : (sk === 5 ? { 'marginTop': '100px' } : (sk === 1 ? { paddingTop: 0, alignItems: "center" } : {}))))}>
                        <div style={sk === 1 ? { display: "flex", justifyContent: "center" } : {}} className={'div-block-story-pic ' + (s.section.paragraph.content[0].label === 'Align Left' ? 'right-align ' : 'left-align ') + '' + ((sk === 1 || sk === 5) ? 'small-img ' : ' ') + '' + (sk === 2 ? 'first-book-pic' : '')}>
                          <img alt="" style={sk === 5 ? { 'maxWidth': '215px', 'maxHeight': '190px' } : {}} src={s.section.picture} />
                        </div>
                        <div className={'startup-storycopy ' + (s.section.paragraph.content[0].label === 'Align Left' ? 'left-align ' : 'right-align ') + '' + ((sk === 1 || sk === 5) ? 'small-img ' : ' ') + '' + (sk === 2 ? 'first-book-text' : '')}>
                          <h3 className="margin-bottom-16px">{s.section.title}</h3>
                          {s.section.paragraph.content.map((p, k) =>
                            <div key={k}>
                              {p.type === 'heading1' &&
                                <h1 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h1>
                              }
                              {p.type === 'heading2' &&
                                <h2 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h2>
                              }
                              {p.type === 'heading3' &&
                                <h3 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h3>
                              }
                              {p.type === 'heading4' &&
                                <h4 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h4>
                              }
                              {p.type === 'heading5' &&
                                <h5 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h5>
                              }
                              {p.type === 'heading6' &&
                                <h6 className="margin-bottom-16px">
                                  {RichText.render([p], LinkResolver)}
                                </h6>
                              }
                              {p.type === 'paragraph' &&
                                <div className='paragraph' style={{ maxWidth: '100%' }}>{RichText.render([p], LinkResolver)}</div>
                              }
                            </div>
                          )}
                        </div>
                      </div>
                    }
                    {s.type === 'picture_duo' &&
                      <div className="article-container w-clearfix" style={{ 'maxHeight': '530px', maxWidth: '95%' }}>
                        <div className="twoimages-about w-row">
                          <div>
                            <img alt="" className="twoimages-about-img extra-padding" style={{ 'width': '100%', 'height': '100%', 'paddingRight': '40px' }} src={s.pictureDuo[0].picture} />
                          </div>
                          <div>
                            <img alt="" className="twoimages-about-img" style={{ 'width': '100%', 'height': '100%' }} src={s.pictureDuo[1].picture} />
                          </div>
                        </div>
                      </div>
                    }
                    {s.type === 'inline_picture' &&
                      <div className="article-container w-clearfix">
                        <div className="article-content-image-and-caption">
                          <img alt="" src={s.inlinePicture.picture} />
                          <p className="image-caption left">{s.inlinePicture.caption}</p>
                        </div>
                      </div>
                    }
                  </div>
                )}
              </div>
              <div data-w-tab="Team" className={"w-tab-pane" + (hash === '#team' ? 'w--tab-active' : '')}>
                <div className="team-page">
                  <div className="div-block-144" style={{ flexWrap: 'unset' }}>
                    {
                      team.filter((e) => { return e.type === 'paragraph' }).map(e =>
                        e.paragraph.content.map((p, k) =>
                          <div key={k}>
                            {p.type === 'heading1' &&
                              <h1 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h1>
                            }
                            {p.type === 'heading2' &&
                              <h2 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h2>
                            }
                            {p.type === 'heading3' &&
                              <h3 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h3>
                            }
                            {p.type === 'heading4' &&
                              <h4 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h4>
                            }
                            {p.type === 'heading5' &&
                              <h5 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h5>
                            }
                            {p.type === 'heading6' &&
                              <h6 className="margin-bottom-16px">
                                {RichText.render([p], LinkResolver)}
                              </h6>
                            }
                            {
                              p.type === 'paragraph' &&
                              <div className="paragraph-copy">{RichText.render([p], LinkResolver)}</div>
                            }
                          </div>
                        )
                      )
                    }
                  </div>
                </div>
                <div className="team-members" style={{ marginTop: '80px' }}>
                  <div className="div-block-147 w-clearfix">
                    {
                      team.filter((e) => { return e.type === 'team_member' }).map((p, k) =>
                        <div key={k} className="team-member" style={k === 0 ? {
                          gridColumnStart: 1,
                          gridColumnEnd: 2,
                          gridRowStart: 1,
                          gridRowEnd: 2,
                        } : {}}><img alt="" src={p.teamMember.portrait ? p.teamMember.portrait : noImage} className="image-110" />
                          <div className="text-block-104">{p.teamMember.name}<br /></div>
                          <div className="text-block-105">{p.teamMember.occupation}<br /><span className="text-span-10"><span role="img" aria-label="">📍</span> &nbsp;{p.teamMember.location}</span><br /></div>
                          <ul className="article-author-social-icons margin-bottom-0px w-list-unstyled">
                            {p.teamMember.facebook !== '' &&
                              <li className="icon">
                                <a href={p.teamMember.facebook} target="_blank">
                                  <img alt="" src={facebookIcon} width="20" height="20" />
                                </a>
                              </li>
                            }
                            {p.teamMember.twitter !== '' &&
                              <li className="icon">
                                <a href={p.teamMember.twitter} target="_blank">
                                  <img alt="" src={twitterIcon} width="20" height="20" />
                                </a>
                              </li>
                            }
                            {p.teamMember.instagram !== '' &&
                              <li className="icon">
                                <a href={p.teamMember.instagram} target="_blank">
                                  <img alt="" src={instagramIcon} width="24" height="24" />
                                </a>
                              </li>
                            }
                            {p.teamMember.linkedin !== '' &&
                              <li className="icon">
                                <a href={p.teamMember.linkedin} target="_blank">
                                  <img alt="" src={linkedinIconGray} width="20" height="20" />
                                </a>
                              </li>
                            }
                            {p.teamMember.website !== '' &&
                              <li className="icon">
                                <a href={p.teamMember.website} target="_blank">
                                  <img alt="" src={mailIcon} width="20" height="20" />
                                </a>
                              </li>
                            }
                          </ul>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
              <div data-w-tab="Contact" className={"w-tab-pane " + (hash === '#contact' ? 'w--tab-active' : '')}>
                <div className="contact-page">
                  <div className="div-block-155">
                    {Array(rowCountBox).fill().map((_, rowIndex) =>
                      <div key={rowIndex} className="columns-2 w-row">
                        {contact.filter((e) => { return e.type === 'contact_box' }).slice(rowIndex * 2, 2 + rowIndex * 2).map((p, k) =>
                          <div key={k} className="column-102 w-col w-col-6 w-col-stack w-col-small-small-stack">
                            <h3 className="margin-bottom-16px center">{p.contactBox.title}<br /></h3>
                            <p className="paragraph-8">{p.contactBox.description}</p>
                            <div className="div-block-157">
                              {p.contactBox.email !== '' &&
                                <span><div className="text-block-107">Contact</div><a href={'mailto:' + p.contactBox.email} className="link-20">{p.contactBox.email}</a></span>
                              }
                              {p.contactBox.link &&
                                <span><div className="div-block-162"><a href={p.contactBox.link} target="_blank" className="link-20">Click here</a></div></span>
                              }
                              {p.contactBox.phone !== '' &&
                                <span><div className="text-block-107">Phone</div><a href={'tel:' + p.contactBox.phone} className="link-20">{p.contactBox.phone}</a></span>
                              }
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="content-contact">
                    <div className="div-block-150">
                      <h3 className="margin-bottom-16px">Visit us</h3>
                    </div>
                    <div>
                      {Array(rowCountVisit).fill().map((_, rowIndex) =>
                        <div className="visit-box" key={rowIndex}>
                          {contact.filter((e) => { return e.type === 'visit_us' }).slice(rowIndex * this.state.mapsPerRow, this.state.mapsPerRow + rowIndex * this.state.mapsPerRow).map((p, k) =>
                            <div key={k} className="map-box">
                              <div className="office-info">
                                <div className="text-block-108">{p.visit.place_name}</div>
                                <div className="div-block-151"><img alt="" src={locationPinIcon} width={22} className="image-112" />
                                  <div className="text-block-109">{p.visit.address ? p.visit.address : 'soon'}</div>
                                </div>
                                <div className="div-block-151"><img alt="" src={openTimesIcon} width={22} className="image-112" />
                                  <div className="text-block-110">{p.visit.working_hours ? p.visit.working_hours : 'soon'}</div>
                                </div>
                                <div className="div-block-151"><img alt="" src={contactIcon} width={22} className="image-112" />
                                  <div><a href="tel:+49(0)30-37468679" className="phonenumber">{p.visit.phone ? p.visit.phone : 'soon'}</a></div>
                                </div>
                                <div className="div-block-151"><img alt="" src={mailIcon} width={22} className="image-112" />
                                  <div><a href="mailto:{p.visit.email?p.visit.email:''}?subject=Hey!" className="link-21">{p.visit.email ? p.visit.email : 'soon'}</a></div>
                                </div>
                              </div>
                              <div data-widget-latlng="{p.visit.map.latitude},{p.visit.map.longitude}" className="map-6 w-widget w-widget-map">
                                <Map
                                  defaultOptions={{ styles: MapStyle }}
                                  defaultZoom={12}
                                  defaultCenter={{
                                    lat: p.visit.map.latitude,
                                    lng: p.visit.map.longitude,
                                  }}
                                >
                                  <Marker position={{ "lat": p.visit.map.latitude, "lng": p.visit.map.longitude }} />
                                </Map>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "150px" }}>
          <NewsletterForm />
        </div>
      </div>
    )
  }
}
